import { useEffect } from "react";

const BASE = "Nitin Narang — President, All India Chess Federation";

export default function usePageTitle(title, description) {
  useEffect(() => {
    document.title = title ? `${title} · ${BASE}` : BASE;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
